export enum TankPlanFilter {
    FosfaAccepted = 1,
    NotFosfaBanned,
    Niop1Accepted,
    Niop2Accepted,
    EuAccepted,
    StowageMode,
}
